const financialAdvisorBeginText=[
    {adviceType: "status", text:  "It is a good idea to seek the advice of a financial advisor from time to time. " +
        "They can help you make a plan and ensure you are on track to meet your financial goals."},
    {adviceType: "endGame", text: ""}
]

export default financialAdvisorBeginText;